module.exports = __webpack_public_path__ + "8df21bd99d2fc15788190b392e54859d.fbx";